import { DatiDepositoDTO } from "./dati-deposito-dto";
import { ProprietarioDTO } from "./proprietario-dto";

export class ParticellaDTO {
	codiceCatastaleComune: string;
	codiceCatasto: string;
	codiceProvincia: string;
	codiceStato: string;
	datiDeposito: DatiDepositoDTO;
	foglio: string;
	idParticella: string;
	particella: string;
	proprietari: Array<ProprietarioDTO>;
	sezione: string;
	subalterno: string;
}